/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Servers_Delete_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Delete MCP server?" |
*
* @param {Mcp_Servers_Delete_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_delete_confirm_title = /** @type {((inputs?: Mcp_Servers_Delete_Confirm_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Delete_Confirm_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("MCP-Server löschen?")
	return /** @type {LocalizedString} */ ("Delete MCP server?")
});